<template>
  <div class="complexion-effect">
    <span>To&nbsp;</span>
    <el-select
      v-close-on-zoom
      placeholder="Select skin condition type"
      class="complexion-select"
      :disabled="readonly"
      :value="state.complexionType"
      @input="(id) => selectComplexion(id)"
    >
      <el-option
        v-for="value in complexions"
        :key="value.key"
        :label="value.label.en"
        :value="value.key"
      />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

export default {
  name: 'complexion-effect',
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'states'],
  data() {
    return {
      state: {
        complexionType: null,
      },
    };
  },
  computed: {
    complexions() {
      return sortBy(
        this.states.find(s => s.id === 'complexion').possibleValues, 
        value => value.label.en
      );
    },
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.complexionType = get(data, 'id') || 'NORMAL',
    this.update();
  },
  methods: {
    selectComplexion(id) {
      this.state.complexionType = id;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'COMPLEXION',
        id: this.state.complexionType,
      });
      this.emitter.trigger('process', this.control);
    },    
  },
}
</script>

<style scoped>
</style>